export const NAV = [
  { label: "What We Do", to: "/what-we-do" },
  { label: "Eazymuv OS", to: "/eazymuv-os" },
  {
    label: "Products",
    children: [
      { label: "Products Overview", to: "/products", desc: "The Eazymuv product ecosystem" },
      { label: "EazyMS", to: "/eazyms", desc: "Warehouse & factory management" },
    ],
  },
  { label: "Industries", to: "/industries" },
  { label: "How We Work", to: "/how-we-work" },
  {
    label: "Company",
    children: [
      { label: "About Eazymuv", to: "/about", desc: "The execution partner" },
      { label: "Our Team", to: "/team", desc: "Founders & operators" },
      { label: "Careers", to: "/careers", desc: "Build execution with us" },
      { label: "Insights", to: "/insights", desc: "Points of view" },
    ],
  },
];

export const OUTCOMES = [
  { k: "One", label: "accountable operating partner", note: "Single point of ownership across plan, warehouse and logistics." },
  { k: "OS", label: "one technology ecosystem", note: "EazyOS connects managed operations and EazyMS into one operating view." },
  { k: "Land", label: "and expand model", note: "Start inside one facility, expand across the network." },
];

export const INDUSTRIES = [
  { name: "FMCG", note: "High-velocity distribution and dense SKU handling." },
  { name: "Food & Frozen", note: "Cold-chain discipline and traceability." },
  { name: "Ice Cream", note: "Temperature-controlled execution at peak seasonality." },
  { name: "Temperature-Controlled", note: "Compliance-grade storage and dispatch." },
  { name: "Consumer Products", note: "Reliable fulfilment across channels." },
  { name: "Manufacturing", note: "Factory-to-warehouse flow as one system." },
];

export const DIFFERENT = [
  { dim: "Accountability", them: "Fragmented across vendors", us: "One accountable execution partner" },
  { dim: "Technology", them: "Bolt-on tools, siloed data", us: "Eazymuv OS — one connected operating view" },
  { dim: "Engagement", them: "Big-bang, high-risk rollouts", us: "Land-and-expand, proven facility by facility" },
  { dim: "Focus", them: "Planning dashboards", us: "On-the-ground execution" },
];

export const FACTORY_FLOW = [
  { n: "01", t: "Start inside the factory", d: "We embed where goods are made and stored — not in a slide deck." },
  { n: "02", t: "Stabilise execution", d: "Bring inventory, labour and dispatch into one operating rhythm." },
  { n: "03", t: "Instrument with Eazymuv OS", d: "Connect EazyMS so the floor and the data tell the same story." },
  { n: "04", t: "Extend across logistics", d: "We coordinate reliable movement of goods across your network." },
  { n: "05", t: "Land and expand", d: "Prove it in one site, then scale across the network." },
];

export const OS_MODULES = [
  { name: "EazyOS", status: "In deployment", desc: "The Eazymuv Operating System — a single operating view across factory, warehouse and logistics. 100% visibility." },
  { name: "EazyMS", status: "Live", desc: "Warehouse & factory management product." },
  { name: "Network Intelligence", status: "Planned", desc: "Cross-network optimisation and insight layer." },
];

// Placeholder team — no invented bios beyond clearly labelled placeholders
export const TEAM = [
  { name: "Founder Name", role: "Founder & CEO", tag: "Founder", note: "Bio to be provided." },
  { name: "Founder Name", role: "Co-founder & COO", tag: "Founder", note: "Bio to be provided." },
  { name: "Leader Name", role: "Head of Product — EazyMS", tag: "Product", note: "Bio to be provided." },
  { name: "Leader Name", role: "Head of Network Operations", tag: "Network", note: "Bio to be provided." },
];

export const STATUS_STYLES = {
  Live: "bg-green-600 text-white",
  "In deployment": "bg-ez-yellow text-ez-text",
  Planned: "bg-ez-text/10 text-ez-text",
};
